<template>
  <v-container class="print-detail" fluid pa-5 px-10>
    <v-layout row wrap ma-0>
      <v-flex xs12 mb-3>
        <p class="title text-left primary--text font-weight-medium">ข้อมูลอุบัติเหตุ</p>
        <v-divider></v-divider>
      </v-flex>
    </v-layout>
    <v-layout row wrap ma-0>
      <v-flex xs12 sm6 pr-2 class="print-col">
        <!-- 1 -->
        <v-layout row wrap ma-0>
          <v-flex class="d-flex flex-row" xs12>
            <div>
              <div class="topic-number d-flex justify-center align-center white--text">
                {{ getTitleOrder(department, 1) }}
              </div>
            </div>
            <div class="d-flex align-self-center">
              <p class="body-2 primary--text font-weight-medium mb-0 ml-2 d-flex align-self-center">
                วันและเวลา
              </p>
            </div>
          </v-flex>

          <v-flex class="d-flex flex-row" xs12 pt-3>
            <v-layout row wrap ma-0>
              <v-flex
                :class="{
                  xs6: $vuetify.breakpoint.width >= 400,
                  'pr-1': $vuetify.breakpoint.width >= 400,
                  xs12: $vuetify.breakpoint.width < 400
                }"
                sm6
                mt-2
              >
                <p class="body-2 primary--text font-weight-medium mb-1 d-flex align-self-center">
                  วัน
                </p>
                <!-- <v-text-field
                  v-model="date"
                  hide-details
                  class="pa-0"
                  my-auto
                  solo
                  flat
                  readonly
                ></v-text-field>-->
                <DatePicker v-if="edit" v-model="date" />
                <p v-else class="body-1 my-3">{{ date || '-' }}</p>
              </v-flex>
              <v-flex
                :class="{
                  xs6: $vuetify.breakpoint.width >= 400,
                  'pl-1': $vuetify.breakpoint.width >= 400,
                  xs12: $vuetify.breakpoint.width < 400,
                  'mt-2': $vuetify.breakpoint.width < 400
                }"
                sm6
                mt-2
              >
                <p class="body-2 primary--text font-weight-medium mb-1 d-flex align-self-center">
                  เวลา
                </p>
                <!-- <v-text-field
                  v-model="time"
                  hide-details
                  class="pa-0"
                  my-auto
                  solo
                  flat
                  readonly
                ></v-text-field>-->
                <TimePicker v-if="edit" v-model="time" />
                <p v-else class="body-1 my-3">{{ time || '-' }}</p>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <!-- 2 -->
        <v-layout row wrap ma-0 mt-5>
          <v-flex class="d-flex flex-row" xs12>
            <div>
              <div class="topic-number d-flex justify-center align-center white--text">
                {{ getTitleOrder(department, 2) }}
              </div>
            </div>
            <div class="d-flex align-self-center">
              <p class="body-2 primary--text font-weight-medium mb-0 ml-2 d-flex align-self-center">
                ตำแหน่งและสถานที่เกิดเหตุ
              </p>
            </div>
          </v-flex>
          <v-flex class="d-flex flex-row" xs12 pt-3>
            <DoubleColumnForm
              :dataSource="form2"
              textName="label"
              textValue="value"
              textModel="model"
              readonly
              isDetail
              :disabled="!edit"
            />
          </v-flex>
          <v-flex class="d-flex flex-row map" xs12 pt-3 v-if="$vuetify.breakpoint.xsOnly">
            <longdo-map :mapOptions="mapOptions" @onload="initMap" />
          </v-flex>
        </v-layout>
        <!-- 3 -->
        <v-layout
          row
          wrap
          ma-0
          mt-5
          v-if="['AAIC', 'DLT', 'SRTET', 'MRT'].indexOf(department) == -1"
        >
          <v-flex class="d-flex flex-row" xs12>
            <div>
              <div class="topic-number d-flex justify-center align-center white--text">
                {{ getTitleOrder(department, 3) }}
              </div>
            </div>
            <div class="d-flex align-self-center">
              <p class="body-2 primary--text font-weight-medium mb-0 ml-2 d-flex align-self-center">
                สิ่งแวดล้อม
              </p>
            </div>
          </v-flex>
          <v-flex class="d-flex flex-row" xs12 pt-3>
            <DoubleColumnForm
              :dataSource="form3"
              textName="label"
              textValue="value"
              textModel="model"
              readonly
              isDetail
              :disabled="!edit"
            />
          </v-flex>
        </v-layout>
        <!-- 4 -->
        <v-layout row wrap ma-0 mt-5 v-if="['AAIC', 'DLT'].indexOf(department) == -1">
          <v-flex class="d-flex flex-row" xs12>
            <div>
              <div class="topic-number d-flex justify-center align-center white--text">
                {{ getTitleOrder(department, 4) }}
              </div>
            </div>
            <div class="d-flex align-self-center">
              <p class="body-2 primary--text font-weight-medium mb-0 ml-2 d-flex align-self-center">
                สาเหตุ (มูลเหตุสันนิษฐาน)
              </p>
            </div>
          </v-flex>
          <v-flex class="d-flex flex-row" xs12 pt-3>
            <DoubleColumnForm
              :dataSource="form4"
              textName="label"
              textValue="value"
              textModel="model"
              readonly
              isDetail
              :disabled="!edit"
            />
          </v-flex>
        </v-layout>
        <!-- 7 -->
        <v-layout row wrap ma-0 mt-5 v-if="!isAir">
          <v-flex class="d-flex flex-row" xs12>
            <div>
              <div class="topic-number d-flex justify-center align-center white--text">
                {{ getTitleOrder(department, 5) }}
              </div>
            </div>
            <div class="d-flex align-self-center">
              <p class="body-2 primary--text font-weight-medium mb-0 ml-2 d-flex align-self-center">
                เหตุบริเวณใกล้เคียงล่าสุด
              </p>
            </div>
          </v-flex>
          <v-flex class="d-flex flex-row" xs12 pt-3>
            <v-layout row wrap ma-0>
              <v-flex xs12 mt-2>
                <v-simple-table class="card-border">
                  <template v-slot:default>
                    <thead class="lightgrey">
                      <tr>
                        <th class="text-center font-weight-regular">วันที่</th>
                        <th class="text-center font-weight-regular">ความรุนแรง</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-if="historyLoading">
                        <td colspan="2">
                          <v-progress-linear height="10" rounded indeterminate></v-progress-linear>
                        </td>
                      </tr>
                      <tr v-else-if="accidentRecords.length == 0">
                        <td colspan="2">ไม่พบข้อมูล</td>
                      </tr>
                      <tr
                        v-for="item in accidentRecords"
                        :key="item.name"
                        class="cursor"
                        @click="goToPage(item.id)"
                      >
                        <td>{{ item.date }}</td>
                        <td>{{ item.severity }}</td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-flex>
              <!-- <v-flex xs12 mt-10 pt-2>
                <highcharts :options="pieOptions" />
              </v-flex> -->
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 sm6 pl-2 class="print-col">
        <!-- Map -->
        <v-layout v-if="location" row wrap ma-0>
          <v-flex class="d-flex flex-row map" xs12 pt-12 v-if="$vuetify.breakpoint.smAndUp">
            <longdo-map :mapOptions="mapOptions" @onload="initMap" />
          </v-flex>
        </v-layout>
        <!-- 5 -->
        <v-layout row wrap ma-0 mt-5 v-if="['AAIC', 'DLT'].indexOf(department) == -1">
          <v-flex class="d-flex flex-row" xs12>
            <div>
              <div class="topic-number d-flex justify-center align-center white--text">
                {{ getTitleOrder(department, 6) }}
              </div>
            </div>
            <div class="d-flex align-self-center">
              <p class="body-2 primary--text font-weight-medium mb-0 ml-2 d-flex align-self-center">
                {{
                  ['MD', 'SRTET', 'MRT'].indexOf(department) == -1
                    ? 'ลักษณะการชน'
                    : 'รายงานเหตุการณ์โดยย่อ'
                }}
              </p>
            </div>
          </v-flex>
          <v-flex class="d-flex flex-row" xs12 pt-3>
            <v-layout row wrap ma-0>
              <v-flex
                v-if="['MD', 'SRTET', 'MRT'].indexOf(department) == -1"
                :class="{
                  xs6: $vuetify.breakpoint.width >= 400,
                  'pr-1': $vuetify.breakpoint.width >= 400,
                  xs12: $vuetify.breakpoint.width < 400
                }"
                sm6
                mt-2
              >
                <p class="body-2 primary--text font-weight-medium mb-1 d-flex align-self-center">
                  รูปแบบการชน
                </p>
                <v-text-field
                  v-if="edit"
                  v-model="crashType"
                  hide-details
                  class="card-border"
                  my-auto
                  solo
                  flat
                ></v-text-field>
                <p v-else class="body-1 my-3">{{ crashType || '-' }}</p>
              </v-flex>
              <v-flex
                :class="{
                  xs6: $vuetify.breakpoint.width >= 400,
                  'pl-1': $vuetify.breakpoint.width >= 400,
                  xs12: $vuetify.breakpoint.width < 400,
                  'mt-2': $vuetify.breakpoint.width < 400
                }"
                sm6
                mt-2
                class="d-flex"
              >
                <div class="image-container d-flex align-end">
                  <div v-for="num in 0" :key="`image-${num}`">
                    <v-img
                      width="55"
                      src="https://picsum.photos/id/11/500/300"
                      class="thumb-img"
                      :aspect-ratio="1 / 1"
                    ></v-img>
                  </div>
                </div>
              </v-flex>
              <v-flex xs12 mt-2>
                <p class="body-2 primary--text font-weight-medium mb-1 d-flex align-self-center">
                  {{
                    department == 'BMTA'
                      ? 'การดำเนินการ / ขอความช่วยเหลือ'
                      : 'รายงานเหตุการณ์โดยย่อ'
                  }}
                </p>
                <v-textarea
                  v-if="edit"
                  v-model="crashTypeDescription"
                  hide-hint
                  :auto-grow="true"
                  my-auto
                  solo
                  flat
                  class="card-border"
                ></v-textarea>
                <p v-else class="body-1 my-3">{{ crashTypeDescription || '-' }}</p>
              </v-flex>
              <v-flex xs12 mt-1 mb-2></v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <!-- 6 -->
        <v-layout row wrap ma-0 v-bind:class="{ 'mt-5': isAir }">
          <v-flex class="d-flex flex-row" xs12>
            <div>
              <div class="topic-number d-flex justify-center align-center white--text">
                {{ getTitleOrder(department, 7) }}
              </div>
            </div>
            <div class="d-flex align-self-center">
              <p class="body-2 primary--text font-weight-medium mb-0 ml-2 d-flex align-self-center">
                สรุปความเสียหาย
              </p>
            </div>
          </v-flex>
          <v-flex xs12 pt-2></v-flex>
          <!-- New table Here -->
          <v-simple-table
            v-if="isAir"
            style="width:100%"
            class="card-border departmentdamagetable"
            :dense="true"
          >
            <thead class="lightgrey">
              <th colspan="2" class="text-center body-1">
                ความเสียหายต่อตัวบุคคล
              </th>
            </thead>
            <tbody>
              <tr>
                <td>ผู้เสียชีวิต</td>
                <td>ผู้บาดเจ็บ</td>
              </tr>
              <tr>
                <td>{{ dead }}</td>
                <td>{{ injury }}</td>
              </tr>
            </tbody>
          </v-simple-table>
          <v-simple-table
            v-else-if="department == 'MD'"
            style="width:100%"
            class="card-border departmentdamagetable"
            :dense="true"
          >
            <thead class="lightgrey">
              <th colspan="4" class="text-center body-1">
                ความเสียหายต่อตัวบุคคล
              </th>
            </thead>
            <tbody>
              <tr>
                <td>ผู้เสียชีวิต</td>
                <td>ผู้บาดเจ็บสาหัส</td>
                <td>ผู้บาดเจ็บเล็กน้อย</td>
                <td>ผู้สูญหาย</td>
              </tr>
              <tr>
                <td>{{ dead }}</td>
                <td>{{ hardInjury }}</td>
                <td>{{ softInjury }}</td>
                <td>{{ missing }}</td>
              </tr>
            </tbody>
          </v-simple-table>
          <v-simple-table
            v-else
            style="width:100%"
            class="card-border summarydamagetable"
            :dense="true"
          >
            <thead class="lightgrey">
              <th colspan="6" class="text-center body-1">
                ความเสียหายต่อตัวบุคคล
              </th>
            </thead>
            <tbody>
              <tr>
                <td colspan="2">ผู้เสียชีวิต ณ จุดเกิดเหตุ (ราย)</td>
                <td colspan="5">{{ suddenlyDead }}</td>
              </tr>
              <tr>
                <td colspan="2">ผู้เสียชีวิต ณ โรงพยาบาล (ราย)*</td>
                <td colspan="5">{{ laterDead }}</td>
              </tr>
              <tr>
                <td colspan="2">ผู้บาดเจ็บสาหัส (ราย)*</td>
                <td colspan="5">{{ hardInjury }}</td>
              </tr>
              <tr>
                <td colspan="2">ผู้บาดเจ็บเล็กน้อย (ราย)</td>
                <td colspan="5">{{ softInjury }}</td>
              </tr>
              <tr>
                <td colspan="2">หมายเหตุ :</td>
                <td colspan="5" class="text-left">
                  1) ผู้เสียชีวิต ณ โรงพยาบาลภายใน 30 วันจากวันเกิดเหตุ<br />
                  2) ผู้บาดเจ็บสาหัส มีการนอนพักที่โรงพยาบาล
                </td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-layout>
        <v-layout v-if="['SRTET', 'MRT'].indexOf(department) == -1" row wrap ma-0 mt-5>
          <v-flex class="d-flex flex-row" xs12>
            <div>
              <div class="topic-number d-flex justify-center align-center white--text">
                {{ getTitleOrder(department, 8) }}
              </div>
            </div>
            <div class="d-flex align-self-center">
              <p class="body-2 primary--text font-weight-medium mb-0 ml-2 d-flex align-self-center">
                ข้อมูลยานพาหนะ/ผู้ใช้ทาง
              </p>
            </div>
          </v-flex>
          <v-flex xs12 pt-2></v-flex>
          <v-simple-table
            v-if="department == 'BMTA'"
            style="width:100%"
            class="card-border summarydamagetable mb-1"
            :dense="true"
          >
            <thead class="lightgrey">
              <th colspan="2" class="text-center body-1 primary--text">
                รถโดยสารสาธารณะ
              </th>
            </thead>
            <tbody>
              <tr>
                <td class="font-weight-medium">หน่วยงาน</td>
                <td>{{ publicVehicle.carType || '-' }}</td>
              </tr>
              <tr>
                <td class="font-weight-medium">ประเภทรถ</td>
                <td>{{ publicVehicle.subCarType || '-' }}</td>
              </tr>
              <tr>
                <td class="font-weight-medium">ชื่อผู้ประกอบการ</td>
                <td>{{ publicVehicle.company || '-' }}</td>
              </tr>
              <tr>
                <td class="font-weight-medium">ชื่อคนขับ</td>
                <td>{{ publicVehicle.driver || '-' }}</td>
              </tr>
              <tr>
                <td class="font-weight-medium">หมายเลขทะเบียน</td>
                <td>{{ publicVehicle.publicCarNumber || '-' }}</td>
              </tr>
            </tbody>
          </v-simple-table>
          <!-- New table Here -->
          <div v-for="(data, idx) in vehicle" :key="data.vehicle_id" style="width:100%">
            <v-simple-table style="width:100%" class="card-border summarydamagetable" :dense="true">
              <thead class="lightgrey">
                <th colspan="2" class="text-center body-1 primary--text">
                  ยานพาหนะคันที่ {{ idx + 1 }}
                </th>
              </thead>
              <tbody>
                <tr>
                  <td class="font-weight-medium">ประเภท</td>
                  <td>{{ data.vehicle_type }}</td>
                </tr>
                <tr>
                  <td class="font-weight-medium">ทะเบียน{{ vehicleCategory }}</td>
                  <td>
                    {{
                      data.vehicle_registration && data.vehicle_registration != ''
                        ? data.vehicle_registration
                        : '-'
                    }}
                  </td>
                </tr>
                <tr v-show="vehicleCategory == 'เรือ'">
                  <td class="font-weight-medium">ลักษณะการใช้งาน</td>
                  <td>
                    {{
                      data.vehicle_use_type && data.vehicle_use_type != ''
                        ? data.vehicle_use_type
                        : '-'
                    }}
                  </td>
                </tr>
                <tr v-show="vehicleCategory == 'เรือ'">
                  <td class="font-weight-medium">ความเสียหาย</td>
                  <td>
                    {{
                      data.vehicle_damage_type && data.vehicle_damage_type != ''
                        ? data.vehicle_damage_type
                        : '-'
                    }}
                  </td>
                </tr>
                <tr v-show="vehicleCategory == 'รถ'">
                  <td class="font-weight-medium">จังหวัด</td>
                  <td>
                    {{
                      data.vehicle_province && data.vehicle_province != ''
                        ? data.vehicle_province
                        : '-'
                    }}
                  </td>
                </tr>
                <tr v-show="vehicleCategory == 'รถ'">
                  <td class="font-weight-medium">ยี่ห้อรถ</td>
                  <td>
                    {{ data.vehicle_brand && data.vehicle_brand != '' ? data.vehicle_brand : '-' }}
                  </td>
                </tr>
                <tr v-show="vehicleCategory == 'รถ'">
                  <td class="font-weight-medium">สีรถ</td>
                  <td>
                    {{ data.vehicle_color && data.vehicle_color != '' ? data.vehicle_color : '-' }}
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
            <div v-for="p in data.casualty" :key="p.id" style="width:100%">
              <v-simple-table
                style="width:100%"
                class="card-border summarydamagetable mb-5 mt-1"
                :dense="true"
              >
                <thead class="lightgrey">
                  <th colspan="2" class="text-center body-1">
                    ข้อมูลผู้ใช้ทาง คันที่ {{ idx + 1 }}
                  </th>
                </thead>
                <tbody>
                  <tr>
                    <td class="font-weight-medium">หมายเลขบัตรประชาชน/พาสปอร์ต</td>
                    <td>{{ p.id_card && p.id_card != '' ? p.id_card : '-' }}</td>
                  </tr>
                  <tr>
                    <td class="font-weight-medium">อายุ</td>
                    <td>{{ p.age && p.age != '' ? p.age : '-' }}</td>
                  </tr>
                  <tr>
                    <td class="font-weight-medium">เพศ</td>
                    <td>{{ p.sex && p.sex != '' ? p.sex : '-' }}</td>
                  </tr>
                  <tr>
                    <td class="font-weight-medium">อุปกรณ์ป้องกัน</td>
                    <td>{{ p.safety && p.safety != '' ? p.safety : '-' }}</td>
                  </tr>
                  <tr>
                    <td class="font-weight-medium">ที่อยู่</td>
                    <td>{{ p.address && p.address != '' ? p.address : '-' }}</td>
                  </tr>
                  <tr>
                    <td class="font-weight-medium">ตำบล</td>
                    <td>{{ p.tambon && p.tambon != '' ? p.tambon : '-' }}</td>
                  </tr>
                  <tr>
                    <td class="font-weight-medium">อำเภอ</td>
                    <td>{{ p.amphoe && p.amphoe != '' ? p.amphoe : '-' }}</td>
                  </tr>
                  <tr>
                    <td class="font-weight-medium">จังหวัด</td>
                    <td>{{ p.province && p.province != '' ? p.province : '-' }}</td>
                  </tr>
                  <tr>
                    <td class="font-weight-medium">ความรุนแรง</td>
                    <td>{{ p.damage && p.damage != '' ? p.damage : '-' }}</td>
                  </tr>
                </tbody>
              </v-simple-table>
            </div>
          </div>
        </v-layout>
      </v-flex>
      <v-flex class="print-btn d-flex flex-column flex-sm-row align-end mt-4">
        <v-btn
          :block="$vuetify.breakpoint.xsOnly"
          rounded
          outlined
          width="120"
          color="primary"
          class="mt-2"
          @click="printDetail"
          >พิมพ์รายงาน</v-btn
        >
        <!-- <v-spacer></v-spacer>
        <v-btn
          :block="$vuetify.breakpoint.xsOnly"
          rounded
          width="120"
          color="primary"
          class="mt-2 ml-2"
        >
          ปิด
        </v-btn>-->
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import DatePicker from '../global/DatePicker.vue';
import TimePicker from '../global/TimePicker.vue';
// import Form1 from './Form1.vue';
// import Form2 from './Form2.vue';
// import FormImage from './FormImage.vue';
import DoubleColumnForm from './DoubleColumnForm.vue';

export default {
  name: 'Default',
  props: {
    accident: {
      type: Object
    },
    history_nearby: {
      type: Array
    },
    edit: {
      type: Boolean,
      default: false
    }
  },
  components: {
    DatePicker,
    TimePicker,
    // Form1,
    // Form2,
    // FormImage,
    DoubleColumnForm
  },
  data: () => ({
    accidentRecords: [],
    vehicle: [],
    casualty: [],
    suddenlyDeadAmount: [
      {
        name: 'ชาย - ผู้ใหญ่',
        code: 'suddenly_dead_m',
        amount: '0'
      },
      {
        name: 'ชาย - เด็ก',
        code: 'suddenly_dead_b',
        amount: '0'
      },

      {
        name: 'หญิง - ผู้ใหญ่',
        code: 'suddenly_dead_f',
        amount: '0'
      },
      {
        name: 'หญิง - เด็ก',
        code: 'suddenly_dead_g',
        amount: '0'
      }
    ],
    deadLaterAmount: [
      {
        name: 'ชาย - ผู้ใหญ่',
        code: 'later_dead_m',
        amount: '0'
      },
      {
        name: 'ชาย - เด็ก',
        code: 'later_dead_b',
        amount: '0'
      },

      {
        name: 'หญิง - ผู้ใหญ่',
        code: 'later_dead_f',
        amount: '0'
      },
      {
        name: 'หญิง - เด็ก',
        code: 'later_dead_g',
        amount: '0'
      }
    ],
    hardInjuryAmount: [
      {
        name: 'ชาย - ผู้ใหญ่',
        code: 'hard_injured_m',
        amount: '0'
      },
      {
        name: 'ชาย - เด็ก',
        code: 'hard_injured_b',
        amount: '0'
      },

      {
        name: 'หญิง - ผู้ใหญ่',
        code: 'hard_injured_f',
        amount: '0'
      },
      {
        name: 'หญิง - เด็ก',
        code: 'hard_injured_g',
        amount: '0'
      }
    ],
    softInjuryAmount: [
      {
        name: 'ชาย - ผู้ใหญ่',
        code: 'soft_injured_m',
        amount: '0'
      },
      {
        name: 'ชาย - เด็ก',
        code: 'soft_injured_b',
        amount: '0'
      },

      {
        name: 'หญิง - ผู้ใหญ่',
        code: 'soft_injured_f',
        amount: '0'
      },
      {
        name: 'หญิง - เด็ก',
        code: 'soft_injured_g',
        amount: '0'
      }
    ],
    map: {},
    mapOptions: {
      ui: false,
      zoomRange: {
        max: 18,
        min: 3
      }
    },
    location: null,
    //
    date: '',
    time: '',
    form2: [],
    form3: [],
    form4: [],
    crashType: '',
    crashTypeDescription: '',
    vehicleCategory: 'รถ',
    isAir: false,
    department: null,
    historyLoading: false,
    dead: 0,
    injury: 0,
    hardInjury: 0,
    softInjury: 0,
    suddenlyDead: 0,
    laterDead: 0,
    missing: 0,
    publicVehicle: {}
    // pieOptions: {
    //   chart: {
    //     type: 'pie'
    //   },
    //   title: {
    //     text: 'จำนวนอุบัติเหตุในช่วง 3 ปี',
    //     style: {
    //       fontSize: '18px',
    //       fontFamily: 'Sarabun'
    //     }
    //   },
    //   lang: {
    //     noData: 'ไม่มีข้อมูล'
    //   },
    //   noData: {
    //     style: {
    //       fontSize: '18px',
    //       fontFamily: 'Sarabun',
    //       fontWeight: '400',
    //       color: '#333333'
    //     }
    //   },
    //   subtitle: {
    //     text: 'แยกตามประเภทยานพาหนะ', // + this.countCommercialAmount,
    //     style: {
    //       fontSize: '14px',
    //       fontFamily: 'Sarabun'
    //     }
    //   },
    //   tooltip: {
    //     headerFormat: '<span style="font-size:11px">{series.name}</span><br/>',
    //     pointFormat: '{point.name}: <b>{point.y} ครั้ง</b>'
    //   },
    //   plotOptions: {
    //     pie: {
    //       cursor: 'pointer',
    //       showInLegend: true
    //     }
    //   },
    //   colors: {},
    //   series: [
    //     {
    //       name: 'จำนวนอุบัติเหตุ',
    //       dataLabels: {
    //         enabled: true,
    //         format: '<b>{point.name}</b>:<br>{point.percentage:.1f} %<br>',
    //         style: {
    //           color: 'black',
    //           fontSize: '14',
    //           'font-family': 'Sarabun',
    //           fontWeight: '500',
    //           textOutline: '0px #F5F5F5'
    //         }
    //       },
    //       data: [],
    //       slicedOffset: 0,
    //       events: {
    //         click: data => {
    //           // this.chartClicked(data, 'pie');
    //         }
    //       }
    //     }
    //   ],
    //   credits: {
    //     enabled: false
    //   }
    // }
  }),
  created() {
    this.historyLoading = true;
    if (this.$props.accident) {
      this.updateAccident(this.$props.accident);
    }
    if (this.$props.history_nearby) {
      this.updateHistoryNearby(this.$props.history_nearby);
    }
  },
  mounted() {
    // this.initChart();
    // this.initMap();
  },
  methods: {
    // initChart() {
    //   this.pieOptions.colors = [this.brownie, this.mastard, this.matcha];
    // },
    initMap(map) {
      this.map = map;
      window.mapdebug = this.map;
      this.map.zoom(18);
      if (this.location) {
        this.map.location(this.location);

        const marker = new window.longdo.Marker(this.location);
        this.map.Overlays.add(marker);
      } else {
        this.map.location({
          lat: 13.7589,
          lon: 100.5076
        });
      }
      this.map.Ui.Mouse.enableDrag(false);
      window.lastLocation = this.map.location();
      this.map.Event.bind('location', function() {
        lastLocation = mapdebug.location();
      });
      this.map.Event.bind('zoom', function() {
        if (lastLocation) {
          mapdebug.location(lastLocation, false);
        }
      });

      this.getMapLayer();
    },
    updateAccident(val) {
      const watertype_th = '';
      let accident_place = '';
      let routeCodeTitle = 'หมายเลขสายทาง';
      this.date = val.accident_date;
      this.time = val.accident_time;
      this.crashType = val.accident_pattern;
      this.isAir = val.accident_type == 'air';
      this.department = val.department;
      this.crashTypeDescription =
        val.department == 'BMTA' ? val.further_process_specify : val.summary;
      this.dead = val.dead;
      this.injury = val.injury;
      this.hardInjury = val.hard_injured;
      this.softInjury = val.soft_injured;
      this.suddenlyDead = val.suddenly_dead;
      this.laterDead = val.later_dead;

      if (val.accident_type == 'water') {
        if (val.watertype == 'Sea') accident_place = 'ทะเล';
        else if (val.watertype == 'River') accident_place = 'แม่น้ำ';
        else if (val.watertype == 'Canal') accident_place = 'คลอง';
        else accident_place = val.watertype;
        this.vehicleCategory = 'เรือ';
        this.missing = val.missing;
      } else if (val.accident_type == 'air') {
        accident_place = val.airname;
      } else if (val.department == 'SRTET') {
        accident_place = val.arl_station;
      } else if (val.department == 'MRT') {
        accident_place = val.mrt_station;
      }

      if (val.department == 'BMTA') {
        this.publicVehicle = {
          carType: val.car_type,
          subCarType: val.sub_car_type,
          company: val.company,
          driver: val.driver,
          publicCarNumber: val.public_car_number
        };
      }

      if (val.department == 'SRT') {
        routeCodeTitle = 'ขบวน';
      } else if (val.department == 'MRT' || val.department == 'SRTET') {
        routeCodeTitle = 'สายทาง';
      }

      this.form2 = [
        {
          label: 'ประเภทสายทาง/หน่วยงาน',
          model: 'department',
          value: val.roadtype || val.department_th
        },
        {
          label: routeCodeTitle,
          model: 'route_code',
          value: val.route_code
        },
        {
          label: 'สถานที่เกิดเหตุ',
          model: 'accident_place',
          value: accident_place
        },
        {
          label: 'รายละเอียดที่เกิดเหตุ',
          model: 'spec_location',
          value: val.spec_location
        },
        {
          label: val.accident_type == 'water' ? 'ตำบล อำเภอ จังหวัดที่เกิดเหตุ' : 'ชื่อสายทาง',
          model: 'route_name',
          value: val.route_name
        },
        {
          label: 'ตอนควบคุม',
          model: 'controlsection',
          value: val.controlsection
        },
        {
          label: 'กิโลเมตรที่เกิดเหตุ',
          model: 'km',
          value: val.km
        },
        {
          label: 'จำนวนช่องจราจร',
          model: 'lane_num',
          value: val.lane_num
        },
        {
          label: 'ระดับของเหตุการณ์',
          model: 'occurrence_class',
          value: val.occurrence_class
        },
        {
          label: 'ละติจูด',
          model: 'latitude',
          value: val.location && val.location.latitude > 0 ? val.location.latitude : '-'
        },
        {
          label: 'ลองจิจูด',
          model: 'longitude',
          value: val.location && val.location.longitude > 0 ? val.location.longitude : '-'
        },
        {
          label: 'ทิศทาง',
          model: 'direction',
          value: val.direction || val.mrt_direction
        },
        {
          label: 'ผิวจราจร',
          model: 'surface',
          value: val.surface
        },
        {
          label: 'ตำบล',
          model: 'tambon',
          value: val.tambon
        },
        {
          label: 'อำเภอ',
          model: 'amphoe',
          value: val.amphoe
        },
        {
          label: 'จังหวัด',
          model: 'province',
          value: val.province
        },
        {
          label: 'ลักษณะบริเวณ',
          model: 'surround_character',
          value: val.surround_character
        },
        {
          label: 'สภาพพิ้นผิวทางขณะเกิดเหตุ',
          model: 'surround_road',
          value: val.surround_road
        },
        {
          label: 'คุณภาพพิ้นผิวทางขณะเกิดเหตุ',
          model: 'surround_road_quality',
          value: val.surround_road_quality
        },
        {
          label: 'การควบคุมการใช้ทางบริเวณที่เกิดเหตุ',
          model: 'surround_control',
          value: val.surround_control ? val.surround_control.join(', ') : '-'
        },
        {
          label: 'อุปกรณ์อำนวยความปลอดภัย',
          model: 'safety_tool',
          value: val.safety_tool
        }
      ];
      this.form3 = [
        {
          label: 'สภาพภูมิอากาศ',
          model: 'surround_weather',
          value: val.surround_weather
        },
        {
          label: 'แสงสว่าง',
          model: 'surround_light',
          value: val.surround_light
        }
      ];
      this.form4 = [
        this.getFirstCause(val),
        {
          label: 'สาเหตุด้านสภาพสายทาง',
          model: 'cause_surround',
          value: val.cause_surround ? val.cause_surround.join(', ') : '-'
        },
        {
          label: 'สาเหตุด้านยานพาหนะ',
          model: 'cause_vehicle',
          value: val.cause_vehicle ? val.cause_vehicle.join(', ') : '-'
        },
        {
          label: 'ข้อเสนอแนะแนวทางแก้ไขเบื้องต้น',
          model: 'suggestion',
          value: val.suggestion
        },
        {
          label: 'ประเภทของเหตุการณ์',
          model: 'cause_category',
          value: val.mrt_category || val.arl_category
        },
        {
          label: 'ระดับของเหตุการณ์',
          model: 'cause_class',
          value: val.mrt_class || val.arl_type
        }
      ];

      if (val.location && val.location.latitude && val.location.longitude) {
        this.location = {
          lat: val.location.latitude,
          lon: val.location.longitude
        };
      }
      let ignore = [];
      let causeIgnore = ['suggestion', 'cause_surround', 'cause_vehicle'];
      if (val.accident_type == 'rail') {
        ignore = [
          'surround_road',
          'surround_road_quality',
          'surround_control',
          'safety_tool',
          'occurrence_class'
        ];
        if (val.department == 'MRT' || val.department == 'SRTET') {
          ignore.push(
            'surface',
            'surround_character',
            'route_name',
            'controlsection',
            'km',
            'lane_num'
          );
        } else {
          ignore.push('surface', 'accident_place', 'spec_location', 'controlsection', 'lane_num');
          causeIgnore.push('cause_category', 'cause_class');
        }
      } else if (val.accident_type == 'water') {
        ignore = [
          'department',
          'route_code',
          'controlsection',
          'km',
          'direction',
          'surface',
          'surround_character',
          'surround_road',
          'surround_road_quality',
          'surround_control',
          'safety_tool',
          'occurrence_class',
          'spec_location'
        ];
        if (val.province) {
          ignore.push('route_name');
        } else {
          ignore.push('tambon', 'amphoe', 'province');
        }
        causeIgnore.push('cause_category', 'cause_class');
      } else if (val.accident_type == 'air') {
        ignore = [
          'department',
          'route_code',
          'route_name',
          'controlsection',
          'km',
          'surround_character',
          'spec_location',
          'surround_road',
          'surround_road_quality',
          'surround_control',
          'safety_tool',
          'direction',
          'surface',
          'lane_num'
        ];
      } else {
        if (val.department == 'BMTA' || val.department == 'EXAT') {
          ignore = [
            'surround_road',
            'surround_road_quality',
            'surround_control',
            'safety_tool',
            'occurrence_class'
          ];
          causeIgnore.push('cause_category', 'cause_class');
        } else if (val.department == 'DLT') {
          ignore = [
            'surround_road',
            'surround_road_quality',
            'surround_control',
            'safety_tool',
            'occurrence_class'
          ];
        } else {
          ignore = ['occurrence_class'];
          if (val.department == 'DOH') {
            causeIgnore.push('cause_category', 'cause_class');
          } else {
            causeIgnore = ['cause_category', 'cause_class'];
          }
        }
        ignore.push('accident_place', 'spec_location');
      }
      this.form2 = this.form2.filter(item => ignore.indexOf(item.model) == -1);
      this.form4 = this.form4.filter(item => causeIgnore.indexOf(item.model) == -1);

      this.suddenlyDeadAmount = this.suddenlyDeadAmount.map(this.mapCasualty);
      this.deadLaterAmount = this.deadLaterAmount.map(this.mapCasualty);
      this.hardInjuryAmount = this.hardInjuryAmount.map(this.mapCasualty);
      this.softInjuryAmount = this.softInjuryAmount.map(this.mapCasualty);

      // this.pieOptions.series[0].data = this.$props.accident.vehicle_groupby_route.graph.map(item => {
      //   if (item.name == null) {
      //     item.name = 'ไม่ระบุ';
      //   }
      //   item.y = parseInt(item.y, 10);
      //   return item;
      // });
      // console.log(this.pieOptions.series);
      if (val.vehicle) {
        for (let i = 0; i < val.vehicle.length; i++) {
          this.vehicle[i] = val.vehicle[i];
          this.casualty[i] = val.vehicle[i].casualty[0];
        }
      }
    },
    getTitleOrder(department, mainOrder) {
      let list = {};
      if (department == 'DLT') {
        list = { 5: 3, 7: 4, 8: 5 };
      } else if (department == 'SRTET' || department == 'MRT') {
        list = { 4: 3, 5: 4, 6: 5, 7: 6 };
      } else if (department == 'AAIC') {
        list = { 7: 3, 8: 4 };
      }
      return list[mainOrder] || mainOrder;
    },
    updateHistoryNearby(val) {
      this.historyLoading = false;
      this.accidentRecords = val.map(item => {
        const severity = [];
        if (item.dead > 0) {
          severity.push(`ผู้เสียชีวิต ${item.dead} ราย`);
        }
        if (item.injury > 0) {
          severity.push(`ผู้บาดเจ็บ ${item.injury} ราย`);
        }
        return {
          id: item.accident_code,
          date: item.accident_date,
          severity: severity.length ? severity.join(' ') : 'ไม่มีผู้เสียชีวิตและบาดเจ็บ'
        };
      });
    },
    getFirstCause(val) {
      const cause = { model: 'cause_user' };
      if (val.accident_type == 'water') {
        cause.label = 'ประเภทสาเหตุ';
        cause.value = val.accident_cause_main;
      } else if (['BMTA', 'EXAT', 'DOH'].indexOf(val.department) != -1) {
        cause.label = 'มูลเหตุสันนิษฐาน';
        cause.value = val.accident_cause_main;
      } else if (val.accident_type == 'rail') {
        cause.label = 'สาเหตุ';
        if (val.department == 'MRT') {
          cause.value = val.mrt_cause;
        } else if (val.department == 'SRTET') {
          cause.value = val.arl_cause;
        } else {
          cause.value = val.accident_cause_main;
        }
      } else {
        cause.label = 'สาเหตุด้านผู้ขับขี่';
        cause.value = val.cause_user ? val.cause_user.join(', ') : '-';
      }
      return cause;
    },
    getMapLayer() {
      const self = this;
      const jsonpAdapter = require('axios-jsonp');

      const baseUrl = 'https://api.nostramap.com/Service/V2/Map/GetPermission?key=';
      const key = `${process.env.VUE_APP_NOSTRA_MAP_KEY}`;

      this.axios({
        url: baseUrl + key,
        adapter: jsonpAdapter
      }).then(response => {
        if (response.status === 200 && response.data.results !== null) {
          self.setBaseMap(response.data.results);
        }
      });
    },
    setBaseMap(layer) {
      const base = layer.filter(x => x.serviceID === '1');
      if (base.length === 1) {
        const nostraSteet = new window.longdo.Layer(false, {
          type: window.longdo.LayerType.ArcGIS_REST,
          url: base[0].serviceURL_L,
          key: base[0].serviceToken_L
        });

        this.map.Layers.setBase(nostraSteet);
      }
    },
    mapCasualty(item) {
      if (this.$props.accident[item.code]) {
        item.amount = this.$props.accident[item.code];
      }
      return item;
    },
    printDetail() {
      window.print();
    },
    goToPage(id) {
      if (id != null) {
        const routeData = this.$router.resolve({ name: 'report_detail', query: { data: id } });
        window.open(routeData.href, '_blank');
      }
    }
  },
  computed: {
    brownie() {
      return this.$vuetify.theme.themes.light.brownie;
    },
    mastard() {
      return this.$vuetify.theme.themes.light.mastard;
    },
    matcha() {
      return this.$vuetify.theme.themes.light.matcha;
    }
  },
  watch: {
    accident(val) {
      this.updateAccident(val);
    },
    history_nearby(val) {
      this.updateHistoryNearby(val);
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  padding: 0;
  background-color: white;
}

.map {
  width: 100%;
  max-height: 400px;
  height: 356px;
}

.hidden {
  visibility: hidden;
}

.thumb-img {
  border-radius: 5px;
  margin-right: 10px;
}

.image-container {
  overflow-y: auto;
}

.v-data-table thead tr th {
  font-weight: 400 !important;
}

th {
  border-bottom: 0 !important;
}

.theme--light.v-data-table tbody tr:hover:not(.v-data-table__expand-row) {
  background: var(--v-hovergrey-base);
}

.departmentdamagetable {
  tr td {
    border-bottom: 1px solid var(--v-lightgrey-base) !important;
    border-right: 1px solid var(--v-lightgrey-base) !important;
  }
}

.summarydamagetable {
  tr td {
    border-bottom: 1px solid var(--v-lightgrey-base) !important;
    border-right: 1px solid var(--v-lightgrey-base) !important;
  }
  tr td:first-child {
    text-align: left !important;
  }
}

@media print {
  .print-col {
    -ms-flex-preferred-size: 100% !important;
    flex-basis: 100% !important;
    -webkit-box-flex: 0 !important;
    -ms-flex-positive: 0 !important;
    flex-grow: 0 !important;
    max-width: 100% !important;
  }
}
</style>
